import {
    Avatar,
    Button,
    CircularProgress,
    ETaskType,
    getCalendarFormat,
    TDataTableColumnsData,
    TDataTableRowData
} from "@cakemail-org/ui-components-v2"
import { Stack } from "@mui/material"
import { t } from "i18next"
import moment from "moment"
import { TGetListingRowsExport } from "./types"


export function getListingColsData(): () => TDataTableColumnsData[] {
    return () => [
        {
            id: "type",
            label: t("general-activity_one")
        },
        {
            id: "details",
            label: t("general-details")
        },
        {
            id: "created_on",
            label: t("general-created_on"),
            sortable: true
        },
        {
            id: "requested_by",
            label: t("general-user_one")
        },
        {
            id: "actions",
            label: ""
        }
    ]
}

export function getListingRows({
    task,
    users,
    handleDownload
}: TGetListingRowsExport): TDataTableRowData {
    const canDownload = moment.unix(task.expires_on).diff(moment()) > 0
    let actions = undefined
    if (task.status === "pending") {
        actions = <CircularProgress variant={task.progress > 0 ? "determinate" : "indeterminate"} value={task.progress} size={28} />

    } else if (task.status === "ready" && canDownload) {
        actions = <Button
            size="small"
            variant="outlined"
            animated
            onClick={(e, btn) => {
                handleDownload(task, btn)
            }}
        >
            {t("general-download")}
        </Button>
    }

    let splitText = task?.description?.split(";;")
    let desc = ""
    let detailTxt = ""

    if (task.type === ETaskType.contacts_export) {
        if (splitText?.length === 2) {
            desc = `${splitText[0]} ${t("general-in-txt")} ${splitText[1]}`
        } else {
            if (task?.payload?.jsonFilter) {
                desc = `${t("general-filtered")}${task.description ? " " + t("general-in-txt") + " " + task.description : ""}`
            } else {
                desc = `${t("general-all-contacts")}${task.description ? " " + t("general-in-txt") + " " + task.description : ""}`
            }
        }

        detailTxt = t("general-contact", { count: task?.payload?.count })
    } else if (task.type === ETaskType.campaigns_reports_export) {
        detailTxt = t("general-campaign_other")
    } else if (task.type === ETaskType.suppressed_emails_export) {
        detailTxt = t("general-emails")
    } else {
        desc = splitText?.[0] || ""
        detailTxt = t("general-activity_other")
    }

    return {
        type: t(`tasks-listing-type-${task.type}`),
        details: desc ?
            `${desc}, ${task?.payload?.count} ${detailTxt}` :
            `${task?.payload?.count} ${detailTxt}`,
        created_on: getCalendarFormat({ unixDate: task.created_on }),
        requested_by: <Stack direction="row" alignItems="center" gap={4}>
            <Avatar
                email={task.requested_by?.email}
                firstName={users?.[task.requested_by?.id]?.first_name || ""}
                lastName={users?.[task.requested_by?.id]?.last_name || ""} />
            {users?.[task.requested_by?.id]?.first_name || ""} {users?.[task.requested_by?.id]?.last_name || ""}
        </Stack>,
        actions: actions
    }
}